import { FC } from 'react'
import { useMediaQuery } from 'react-responsive'

import { CancelIcon, CheckIcon } from '@/ui/icons/answerIcons'
import classNames from 'classnames'

import styles from './AnswerCheck.module.scss'

type AnswerCheckProps = {
  right: boolean
}

const AnswerCheck: FC<AnswerCheckProps> = ({ right }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })

  if (right) {
    return (
      <div className={styles.wrapper}>
        <CheckIcon />
        <span
          className={classNames(
            'text',
            isMobile ? 't-header-h5' : 't-caption-big',
            'text_color_accent',
          )}
        >
          Правильно!
        </span>
      </div>
    )
  }
  return (
    <div className={styles.wrapper}>
      <CancelIcon />
      <span
        className={classNames(
          'text',
          isMobile ? 't-header-h5' : 't-caption-big',
          'text_color_negative',
        )}
      >
        А вот и нет!
      </span>
    </div>
  )
}

export default AnswerCheck
